// Mock data para Mordida de Sonho Pastelaria

export const produtos = {
  bolos: [
    {
      id: 1,
      nome: "Bolo de Chocolate",
      descricao: "Delicioso bolo de chocolate com cobertura cremosa",
      preco: "€25.00",
      imagem: "https://images.unsplash.com/photo-1719428808955-5aec379b33cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxjYWtlcyUyMHN3ZWV0c3xlbnwwfHx8fDE3NzM1NzY4NTl8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 2,
      nome: "Bolo de Noz",
      descricao: "Bolo tradicional português com nozes frescas",
      preco: "€22.00",
      imagem: "https://images.unsplash.com/photo-1558234438-16548a1162c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxjYWtlcyUyMHN3ZWV0c3xlbnwwfHx8fDE3NzM1NzY4NTl8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 3,
      nome: "Bolo de Cenoura",
      descricao: "Bolo fofo de cenoura com cobertura de chocolate",
      preco: "€20.00",
      imagem: "https://images.unsplash.com/photo-1430025460695-1ff7b3c13074?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NjY2Nzd8MHwxfHNlYXJjaHwyfHxjYWtlcyUyMHN3ZWV0c3xlbnwwfHx8fDE3NzM1NzY4NTl8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 4,
      nome: "Bolo de Laranja",
      descricao: "Bolo húmido de laranja com calda",
      preco: "€18.00",
      imagem: "https://images.unsplash.com/photo-1649436401481-f4128d7a3585?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85"
    }
  ],
  bolosAniversarioCasamentos: [
    {
      id: 5,
      nome: "Bolo de Casamento Clássico",
      descricao: "Bolo elegante de 3 andares com decoração personalizada",
      preco: "€350.00",
      imagem: "https://images.unsplash.com/photo-1535254973040-607b474cb50d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwY2FrZXxlbnwwfHx8fDE3NzM1NzY4NjR8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 6,
      nome: "Bolo de Casamento Romântico",
      descricao: "Bolo de 4 andares com flores comestíveis",
      preco: "€450.00",
      imagem: "https://images.unsplash.com/photo-1525257831700-183b9b8bf5c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwY2FrZXxlbnwwfHx8fDE3NzM1NzY4NjR8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 7,
      nome: "Bolo de Aniversário Infantil",
      descricao: "Bolo temático personalizado para crianças",
      preco: "€45.00",
      imagem: "https://images.unsplash.com/photo-1430025460695-1ff7b3c13074?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NjY2Nzd8MHwxfHNlYXJjaHwyfHxjYWtlcyUyMHN3ZWV0c3xlbnwwfHx8fDE3NzM1NzY4NTl8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 8,
      nome: "Bolo de Aniversário Adulto",
      descricao: "Bolo sofisticado com decoração elegante",
      preco: "€55.00",
      imagem: "https://images.unsplash.com/photo-1719428808955-5aec379b33cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxjYWtlcyUyMHN3ZWV0c3xlbnwwfHx8fDE3NzM1NzY4NTl8MA&ixlib=rb-4.1.0&q=85"
    }
  ],
  doces: [
    {
      id: 9,
      nome: "Pastel de Nata",
      descricao: "Tradicional pastel de nata português",
      preco: "€1.50",
      imagem: "https://images.unsplash.com/photo-1737700088869-66f1615d6c9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 10,
      nome: "Éclair",
      descricao: "Éclair recheado com creme de baunilha",
      preco: "€2.50",
      imagem: "https://images.unsplash.com/photo-1737700089128-cbbb2dc71631?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 11,
      nome: "Queijada",
      descricao: "Doce tradicional português de queijo",
      preco: "€1.80",
      imagem: "https://images.unsplash.com/photo-1649436401481-f4128d7a3585?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 12,
      nome: "Bolo de Arroz",
      descricao: "Tradicional bolo de arroz português",
      preco: "€1.20",
      imagem: "https://images.unsplash.com/photo-1430025460695-1ff7b3c13074?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NjY2Nzd8MHwxfHNlYXJjaHwyfHxjYWtlcyUyMHN3ZWV0c3xlbnwwfHx8fDE3NzM1NzY4NTl8MA&ixlib=rb-4.1.0&q=85"
    }
  ],
  salgados: [
    {
      id: 13,
      nome: "Pastel de Carne",
      descricao: "Pastel crocante recheado com carne moída",
      preco: "€2.00",
      imagem: "https://images.unsplash.com/photo-1737700088869-66f1615d6c9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 14,
      nome: "Pastel de Queijo",
      descricao: "Pastel recheado com queijo cremoso",
      preco: "€1.80",
      imagem: "https://images.unsplash.com/photo-1649436401481-f4128d7a3585?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 15,
      nome: "Empada de Frango",
      descricao: "Empada tradicional com recheio de frango",
      preco: "€2.20",
      imagem: "https://images.unsplash.com/photo-1737700089128-cbbb2dc71631?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 16,
      nome: "Rissol de Camarão",
      descricao: "Rissol crocante recheado com camarão",
      preco: "€2.50",
      imagem: "https://images.unsplash.com/photo-1558234438-16548a1162c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxjYWtlcyUyMHN3ZWV0c3xlbnwwfHx8fDE3NzM1NzY4NTl8MA&ixlib=rb-4.1.0&q=85"
    }
  ],
  comer: [
    {
      id: 17,
      nome: "Sanduíche Natural",
      descricao: "Sanduíche fresco com ingredientes selecionados",
      preco: "€4.50",
      imagem: "https://images.unsplash.com/photo-1649436401481-f4128d7a3585?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 18,
      nome: "Tosta Mista",
      descricao: "Tosta quente com queijo e fiambre",
      preco: "€3.50",
      imagem: "https://images.unsplash.com/photo-1737700088869-66f1615d6c9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 19,
      nome: "Croissant com Fiambre",
      descricao: "Croissant fresco recheado com fiambre e queijo",
      preco: "€3.00",
      imagem: "https://images.unsplash.com/photo-1737700089128-cbbb2dc71631?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 20,
      nome: "Pão com Chouriço",
      descricao: "Pão artesanal com chouriço assado",
      preco: "€4.00",
      imagem: "https://images.unsplash.com/photo-1430025460695-1ff7b3c13074?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NjY2Nzd8MHwxfHNlYXJjaHwyfHxjYWtlcyUyMHN3ZWV0c3xlbnwwfHx8fDE3NzM1NzY4NTl8MA&ixlib=rb-4.1.0&q=85"
    }
  ]
};

export const categorias = [
  {
    id: 'bolos',
    nome: 'Bolos',
    descricao: 'Deliciosos bolos caseiros feitos diariamente',
    imagem: 'https://images.unsplash.com/photo-1719428808955-5aec379b33cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxjYWtlcyUyMHN3ZWV0c3xlbnwwfHx8fDE3NzM1NzY4NTl8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'bolosAniversarioCasamentos',
    nome: 'Bolos de Aniversário & Casamentos',
    descricao: 'Bolos personalizados para suas ocasiões especiais',
    imagem: 'https://images.unsplash.com/photo-1535254973040-607b474cb50d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwY2FrZXxlbnwwfHx8fDE3NzM1NzY4NjR8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'doces',
    nome: 'Doces',
    descricao: 'Doces tradicionais portugueses',
    imagem: 'https://images.unsplash.com/photo-1737700088869-66f1615d6c9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'salgados',
    nome: 'Salgados',
    descricao: 'Salgados crocantes e saborosos',
    imagem: 'https://images.unsplash.com/photo-1649436401481-f4128d7a3585?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'comer',
    nome: 'Para Comer',
    descricao: 'Opções deliciosas para refeições rápidas',
    imagem: 'https://images.unsplash.com/photo-1737700089128-cbbb2dc71631?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85'
  }
];

export const sobreNos = {
  titulo: "Sobre a Mordida de Sonho",
  historia: "Fundada em 2015, a Mordida de Sonho é uma pastelaria familiar que combina tradição portuguesa com inovação. Cada produto é feito com amor, usando receitas transmitidas através de gerações e ingredientes da mais alta qualidade.",
  missao: "Nossa missão é proporcionar momentos doces e inesquecíveis através dos nossos produtos artesanais, mantendo viva a tradição da pastelaria portuguesa.",
  valores: [
    "Qualidade acima de tudo",
    "Ingredientes frescos e naturais",
    "Receitas tradicionais portuguesas",
    "Atendimento personalizado",
    "Paixão pela confeitaria"
  ]
};

export const contato = {
  endereco: "Rua das Flores, 123",
  cidade: "Lisboa, Portugal",
  telefone: "+351 21 123 4567",
  email: "info@mordidadesonho.pt",
  horario: {
    semana: "Segunda a Sexta: 7h - 20h",
    sabado: "Sábado: 8h - 19h",
    domingo: "Domingo: 9h - 18h"
  }
};
